import { useApi } from "../../../hooks/useApi";
import { useCallback } from "react";
import { urlReplacer } from "../../../utils";
import { objectToFormData } from "../../../utils/objectToFormData";
import { ApiRoutes } from "../../../constants/apiRoutes";

export default function () {
  const { request } = useApi();
  return {
    fetchCategories: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.SERVICE_CATEGORIES}`,
      });
    }, [request]),

    fetchAll: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.SERVICES}`,
      });
    }, [request]),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_SERVICE_ADMIN, {
            id,
          })}`,
        });
      },
      [request],
    ),
    fetchDetails: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_SERVICE_DETAILS, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchCreate: useCallback(
      async ({ category, ...data }) => {
        return request({
          data: objectToFormData({
            ...data,
            isWithPage: data.isWithPage,
            categoryId: category && category.id,
          }),
          method: "POST",
          url: ApiRoutes.CREATE_SERVICE,
        });
      },
      [request],
    ),

    fetchUpdate: useCallback(
      async ({ id, category, ...data }) => {
        return request({
          data: objectToFormData({
            ...data,
            isWithPage: data.isWithPage,
            categoryId: category && category.id,
          }),
          method: "PUT",
          url: urlReplacer(ApiRoutes.UPDATE_SERVICE, {
            id,
          }),
        });
      },
      [request],
    ),

    fetchDelete: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_SERVICE, { id })}`,
        });
      },
      [request],
    ),
  };
}
